import axiosInstance from "../Axios/axiosInstance";

const getAllCategories = async () => {
  return await axiosInstance.get("/categories/");
};

const getCategoryById = async (id) => {
  return await axiosInstance.get(`/categories/entry/${id}`);
};

const addCategory = async (data) => {
  return await axiosInstance.post("/categories/", data);
};

const updateCategory = async (id, data) => {
  return await axiosInstance.put(`/categories/${id}`, data);
};

const deleteCategory = async (id) => {
  return await axiosInstance.delete(`/categories/${id}`);
};

export default {
  getAllCategories,
  getCategoryById,
  addCategory,
  updateCategory,
  deleteCategory,
};
